import { useState, useEffect } from 'react';
import { Header } from '../../common/Header/Header';
import { papService } from '../../../services/papService';
import { useParams } from 'react-router-dom';
import { notify } from '../../../assets/helpers/toast';
import { capitalize } from '../../../assets/helpers/funciones';
import { VehiclesPAPMembershipTable } from '../../common/Tables/Tables';
import { PAPOldMembershipsTable } from '../../../assets/helpers/tables';
import { MembershipHistoryModal } from '../../common/Modals/Modals';
import { useHistory } from 'react-router-dom';

export const PAPDetails = () => {
  const { clientId, } = useParams();
  const [services, setServices] = useState("");
  const [historyModal, setHistoryModal] = useState(false);
  const history = useHistory();

  const redirectToEdit = (orderId) => {
    history.push(`/afiliations/edit-pap-order/${orderId?._id}`);
  };



  const getLastServices = (clientId) => {
    if (clientId) {
      papService
        .clientServices(clientId)
        .then((response) => {
          if (response.status === 200) {
            setServices(response?.data);
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => { });
    }
  };

  const handleHistoryModal = (membership) => {
    setHistoryModal(!historyModal);
    getLastServices(clientId);
  };

  useEffect(() => {
    getLastServices(clientId);
  }, []);

  return (
    <>
      <Header />
      <MembershipHistoryModal
        modal={historyModal}
        handleModal={handleHistoryModal}
      />
      <div className="container">
        <div className="card incidence-card">
          <div className="title-center-component">
          </div>
          <br />
          <div className="light-gray-line"></div>
          <div className="buttons-center-container">
            <h5>Detalles del Cliente</h5>
          </div>
          <ClientDetail
            client={services?.client}
          />
          <br />
          <div className="light-gray-line"></div>
          <br />
          <div className="buttons-center-container">
            <h5>Detalles de Membresias</h5>
          </div>
          <VehiclesPAPMembershipTable
            header={PAPOldMembershipsTable}
            data={services.plans}
            handleHistoryModal={handleHistoryModal}
            redirectToEdit={redirectToEdit}
            client={services?.client}
          />

        </div>
      </div>
    </>
  );
};

export const ClientDetail = (props) => {
  const { client, } = props;
  return (
    <>
      <div className="filter-button-container"></div>
      <div className="buttons-container"></div>
      <div className="row">
        <div className="col-12">
          <p>
            <b>Nombre y Apellido:</b> {capitalize(client?.firstName)}{' '}
            {capitalize(client?.lastName)}
            <br />
            <b>Identificaión: </b>
            {client?.identification}
            <br />
            <b>Número de Teléfono:</b> {client?.phonePrefix}-
            {client?.phoneNumber}
            <br />
            <b>Correo:</b> {client?.email?.toLowerCase()}
            <br />
          </p>
        </div>
        <div className="col-12 col-lg-6 col-xl-4"></div>
      </div>
    </>
  );
};
